export default "__VITE_ASSET__DeivQM0H__"